import { TabProps } from '@mui/material';

import * as Styled from './styles';

export const Tab = ({ children, ...props }: TabProps) => <Styled.Tab {...props}>{children}</Styled.Tab>;

export default Tab;
